import { useState, useCallback, useEffect, RefObject } from 'react';

function useElementWidth(
  ref: RefObject<HTMLElement | null>
): number | null {
  const [width, setWidth] = useState<number | null>(null);

  const measureWidth = useCallback(() => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  }, [ref]);

  useEffect(() => {
    measureWidth();

    const resizeObserver = new ResizeObserver(measureWidth);
    if (ref.current) {
      resizeObserver.observe(ref.current);
    }

    return () => {
      if (ref.current) {
        resizeObserver.unobserve(ref.current);
      }
    };
  }, [ref, measureWidth]);

  return width;
}

export default useElementWidth;